import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

export class MenuService {
    static async getMenuList() {
        try {
            var inputObj = {
            }

            console.log('SERVICE CALL - getMenuList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Menu/getMenuList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}